/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { type LawSchoolEntity, lawSchoolSchema } from '@axiom/domain';
import { tagSearchResultDtoSchema } from './tag-search-result-dto';

export const lawSchoolSearchResultDtoSchema = lawSchoolSchema.pick({ "id": true, "name": true }).extend({ "tags": z.array(z.lazy(() => tagSearchResultDtoSchema)) });
export type LawSchoolSearchResultDto = Pick<LawSchoolEntity, "id" | "name"> & z.infer<typeof lawSchoolSearchResultDtoSchema>;
